var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    { staticClass: "chart-card", attrs: { shadow: "hover" } },
    [
      _c(
        "div",
        {
          staticClass: "card-header",
          attrs: { slot: "header" },
          slot: "header",
        },
        [
          _c("span", [
            _vm._v(
              _vm._s(
                _vm.title ||
                  "客户揽收情况观察 (Observação da situação de coleta dos clientes)"
              )
            ),
          ]),
          _c("img", {
            staticClass: "export-btn",
            attrs: { src: _vm.exportIcon, alt: "导出" },
            on: { click: _vm.handleExport },
          }),
        ]
      ),
      _c("base-echart", {
        attrs: { options: _vm.chartOption, height: "682px" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }